<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  destroyed() {
//    this.$store.dispatch('portal/init');
  }
}
</script>